export function AgentActivity() {
  return (
    <div>
      <p className="sdw-kicker">Coming soon</p>
      <h1 className="sdw-h1">Activity</h1>
      <p className="sdw-lead">Recent calls, outcomes, and assignments will appear here once the dialler engine is live.</p>
      <div className="sdw-card" style={{ color: "var(--sdw-muted)", fontSize: "0.92rem" }}>
        Placeholder route so navigation and layout can be reviewed early.
      </div>
    </div>
  );
}
